/* eslint-disable no-underscore-dangle */
import { houseSearchType } from '@lib/config'
import { isArray, map, omit, isNumber, uniqBy } from 'lodash-es'

/**
 * 区别marker的唯一性的变量名称
 */
export const uniqueKey = 'uniquePointKey'
export const lngLatStr = 'lngLatStr'

/**
* 获取地图上的请求参数
*/
function getMapboxParam(mapbox) {
  const bounds = mapbox.getBounds()
  const rect = [
    bounds._sw.lng, 
    bounds._ne.lng, 
    bounds._sw.lat, 
    bounds._ne.lat
  ].join(',')
  const mapzoom = mapbox.getZoom()
  const center = mapbox.getCenter().toArray().join(',')

  return {
    rect,
    center,
    mapzoom,
    aggPoints: '1',
  }
}
 
/**
* 获取接口请求时与mapbox相关的参数
*/
export function getFetchParam(mapbox, type, param, needGroup) {
  const { rect, center, mapzoom } = getMapboxParam(mapbox)
  const tmp = type === 'estimate' || type === 'stateHouse'
    ? { rect, center, zoom: mapzoom }
    : { rect, center, mapzoom }

  if(needGroup) {
    tmp.aggPoints = 1
  }

  tmp.listCurrentPage = 1
  if(isNumber(param?.offset) && isNumber(param?.limit)) {
    tmp.listCurrentPage = (param.offset / param.limit) + 1
  }

  return omit({ ...param, ...tmp }, ['limit', 'offset'])
}

/**
* 初始化marker数据
* 并通过lng，lat生成唯一 key
*/
export function initialMarkers(data, needGroup, type) {
  if(!isArray(data)) return data

  const result = map(data, (item) => {
    const tmp = {
      ...(!needGroup ? item : omit(item, ['md5'])),
      [uniqueKey]: `${type}-${item.lng}${item.lat}`,
      [lngLatStr]: `${item.lng}${item.lat}`,
      type,
    }

    if(needGroup) {
      tmp.points = uniqBy(
        isArray(item.points) ? item.points : [],
        (c) => (type === houseSearchType.estimate ? c.id : c.property_id)
      )
    }

    return tmp
  })
  
  return uniqBy(result, (r) => r[uniqueKey])
}
